import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { toggleUrl: String, attribute: String }
  static targets = ["input"]

  toggled(event) {
    const newState = this.inputTarget.checked

    if (!confirm("Are you sure?")) {
      event.preventDefault()
      this.inputTarget.checked = !newState
      return
    }

    document.dispatchEvent(new CustomEvent("split:xhr:start"))

    Rails.ajax({
      type: "patch",
      url: this.toggleUrlValue,
      data: new URLSearchParams({ enabled: newState, toggled_attribute: this.attributeValue }).toString(),
      success: (data) => {
        this.inputTarget.checked = data.enabled
        document.dispatchEvent(new CustomEvent("split:xhr:complete"))
      },
      error: (error) => {
        this.inputTarget.checked = !newState
        console.error(error)
        document.dispatchEvent(new CustomEvent("split:xhr:complete"))
      }
    })
  }
}
